import type { PricingQuoteResponse, ProductCard } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";
import { AUTOID_HD_CONFIG } from "./autoid-detail-content";
import { ProductDetailHdPage } from "./ProductDetailHdPage";

export interface AutoidProductDetailHdProps {
  locale: PepLocale;
  product: ProductCard & { complementary?: ProductCard[] };
  prices: Record<string, PricingQuoteResponse>;
  description: string;
  showDemo: boolean;
  showTrial: boolean;
}

/** AutoID HD — shared ProductDetailHdPage + scan-operator hero assets. */
export function AutoidProductDetailHd(props: AutoidProductDetailHdProps) {
  return <ProductDetailHdPage {...props} config={AUTOID_HD_CONFIG} />;
}
